module.exports = __webpack_public_path__ + "img/chart.2406aea9.svg";